import React, { FC } from "react";
import cn from "classnames";
import { FilteringItem } from "./FilteringItem";
import { IFilteringItem } from "./types";
import { SingleButtonSelector } from "../ButtonSelector/SingleButtonSelector";
import { ISingleButtonSelector } from "../ButtonSelector/types";

interface Props extends ISingleButtonSelector, IFilteringItem {}

export const SingleButtonSelectorFilteringItem: FC<Props> = ({
  label,
  icon,
  className,
  selectorClassName,
  ...props
}) => (
  <FilteringItem label={label} icon={icon}>
    <SingleButtonSelector
      className={cn(
        "flex justify-start items-center !gap-2 flex-wrap",
        className
      )}
      selectorClassName={cn(
        "!w-auto h-7 px-3 py-2 text-base leading-normal",
        selectorClassName
      )}
      {...props}
    />
  </FilteringItem>
);
